import { useState } from 'react';
import FileUpload from '../../../components/others/FileUploader/FileUploader';
import { SelectedFiles } from '../../../components/others/FileUploader/FileUploader.types';
import { TableActions } from '../../../components/others/TableActions';
import { PrimaryButton } from '../../../components/others/ButtonPrimary';
import LavorisService from '../../../services/LavorisService';
import { useSelector } from 'react-redux';
import { RootState } from '../../../store/combineReducer';
import { useForm } from 'react-hook-form';
import { CircularProgress } from '@mui/material';
import { useAlert } from '../../../hooks/useAlert';


type MProps = {
  onClose: Function;
  refreshFunction?: Function;
}

const ImportAplicants = ({
  onClose,
  refreshFunction
}: MProps) => {
  const companyId = useSelector((state: RootState) => state.user.currentCompany || state.user.companies[0]);
  const LavorisInstance = LavorisService.getInstance();
  const { showAlert } = useAlert()
  const [isLoading, setIsLoading] = useState(false)
  const [selectedFiles, setSelectedFiles] = useState<SelectedFiles | any>();
  const { handleSubmit } = useForm({ mode: "all", });
  const uploadFiles = (files: File[]) => {
    setSelectedFiles({
      file: files,
      companyId: companyId.id,
    });
  };
  const downloadFileToPc = () => {
    const link = document.createElement("a");
    link.href =
      "https://lavoristotem.s3.amazonaws.com/ImportacionPostulantesV2+.xlsx";
    link.click();
  };

  const addMultipleAplicants = async () => {
    if (
      !selectedFiles ||
      !Array.isArray(selectedFiles.file) ||
      selectedFiles.file.length === 0
    ) {
      alert("No deje el campo vacío");
      setIsLoading(false);
      return;
    }

    setIsLoading(true);
    const formData = new FormData();
    formData.append("file", selectedFiles.file[0]);

    await LavorisInstance.CompanyServices.addMultipleAplicants(
      selectedFiles.companyId,
      formData,
    )
      .then(() => {
        refreshFunction?.()
      })
      .catch((e: any) => {
        //TODO:Create a better alert Modal
        const message = e?.response?.data?.message;
        if (message === "Relation already exists") {
          alert(
            `Algunos aplicantes ya se encuentran en el sistema. Revisa el excel y elimine los que ya están cargados.`,
          );
        } else {
          showAlert(message);
        }
      })
      .finally(() => setIsLoading(false));
  };

  if (!companyId.id) <CircularProgress color="error" size={15} />;
  return (
    <div className="max-w-fit flex flex-col">
      <div className="flex flex-col m-2">
        <h3 className="text-sm font-bold tex-[#343030] mb-2">Paso 1</h3>
        <span className="font-normal text-[13px] tex-[#343030]">
          Descargar la siguiente planilla de excel para completar con los
          datos de sus Postulantes.
        </span>
        <div className="flex my-5 justify-between">
          <h3 className="text-sm font-bold tex-[#343030] mb-1">
            Descargar planilla Postulantes
          </h3>
          <TableActions type="Download" onClick={downloadFileToPc} />
        </div>
        <div className="bg-gray-100 p-3 rounded text-sm flex flex-column gap-2">
          <img src="/images/Alert.svg" alt="alertIcon" style={{ width: "40px" }} />
          <div>
            <span className="text-danger mt-3">
              No modificar la estructura de la planilla para evitar errores en
              la importación de datos.
            </span>
          </div>
        </div>
        {/* <span className="font-normal text-[13px] tex-[#343030] mt-3">
            ID de la compañía: <strong>{companyId.id}</strong>{" "}
          </span> */}
        <hr className="mt-5" />
      </div>
      <div className="flex flex-col m-2">
        <h3 className="text-sm font-bold tex-[#343030] mb-2">Paso 2</h3>
        <div className="my-3">
          <form onSubmit={handleSubmit(addMultipleAplicants)}>
            <h3 className="font-normal text-[13px] tex-[#343030]">
              Subir planilla Postulantes ya completa
            </h3>
            <div className="flex flex-col align-middle h-fit m-[auto]">
              <div
                className={`${selectedFiles?.file?.length ? " h-fit" : "w-100"
                  }    mt-2`}
              >
                <FileUpload
                  label="Archivo"
                  updateFilesCb={uploadFiles}
                  maxFileSizeInBytes={500000}
                  accept=".xls,.xlsx"
                  imageFile="/images/upload2.svg"
                />
              </div>
              {selectedFiles?.file?.length > 0 && (
                <PrimaryButton
                  type="submit"
                  text="Importar"
                  disabled={isLoading}
                  styles={`bg-red-500 font-bold text-white  m-[auto] mt-2  w-100 }`}
                />
              )}
            </div>
          </form>
        </div>
        {/*  <hr className="mt-5" />
          <h3 className="text-sm font-bold tex-[#343030] my-2 ">Paso 3</h3>
          <span className="font-normal text-[13px] tex-[#343030]">
            Actualizar la dirección de cada empleado para la geolocalización.
          </span> */}
      </div>
    </div>
  );
}

export default ImportAplicants